import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import HistoryHome from './HistoryHome'

function HistoryIndex () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`} exact>
        <HistoryHome />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default HistoryIndex
